import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { DragulaService } from 'ng2-dragula';

@Component({
	selector: 'invoice-update-dnd',
	template: require('./invoice-update-dnd.html'),
	styles: [require('./invoice-update-dnd.scss')]
})
export class InvoiceUpdateDnd implements OnInit, OnDestroy {
	@Input() isDiscounts: boolean;
	@Input('products') products;
	@Input('companyCurrencyAndTaxes') companyCurrencyAndTaxes;
	@Input('productsNames') productsNames;
	@Output('productStateChange')
	productStateChange: EventEmitter<void> = new EventEmitter();

	dragulaProductsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};
	dragulaDiscountsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};

	constructor(private dragulaService: DragulaService) {}

	ngOnInit(): void {
		this.setDragulaOptions();
	}

	ngOnDestroy(): void {
		this.clear();
	}

	private clear(): void {
		this.isDiscounts
			? this.dragulaService.destroy('discounts')
			: this.dragulaService.destroy('products');
	}

	private setDragulaOptions(): void {
		this.isDiscounts
			? this.dragulaService.setOptions(
					'discounts',
					this.dragulaDiscountsOptions
			  )
			: this.dragulaService.setOptions('products', this.dragulaProductsOptions);
	}

	removeProduct(itemToDelete): void {
		this.isDiscounts
			? this.products.splice(itemToDelete, 1)
			: this.products.splice(itemToDelete.index, 1);
		this.productStateChange.emit();
	}

	setNewProduct(product): void {
		this.products.forEach((productItem, index) => {
			if (index === product.index) {
				this.products[index] = JSON.parse(
					JSON.stringify(Object.assign({}, product.product))
				);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.ts